import React from 'react';
import { getConfig } from '@edx/frontend-platform';
import { FormattedMessage } from '@edx/frontend-platform/i18n';
import messages from './messages';

const getDashboardMenu = () => {
  const { ACCOUNT_SETTINGS_URL, DASHBOARD_URL } = getConfig();

  const DashboardMenu = [
    {
      icon: 'home-2',
      text: <FormattedMessage {...messages.home} />,
      href: DASHBOARD_URL,
    },
    {
      icon: 'search',
      text: <FormattedMessage {...messages.discover} />,
      children: [
        {
          text: <FormattedMessage {...messages.discoverAll} />,
          href: DASHBOARD_URL + 'discover',
        },
        {
          text: <FormattedMessage {...messages.discoverWishlist} />,
          href: DASHBOARD_URL + 'wishlist',
        },
      ],
    },
    {
      icon: 'lightbulb',
      text: <FormattedMessage {...messages.myLearning} />,
      href: DASHBOARD_URL + 'learning',
    },
    {
      icon: 'progress-6',
      text: <FormattedMessage {...messages.progress} />,
      href: DASHBOARD_URL + 'progress',
    },
    {
      icon: 'calendar-event',
      text: <FormattedMessage {...messages.schedule} />,
      href: DASHBOARD_URL + 'calendar',
    },
    {
      icon: 'bell',
      text: <FormattedMessage {...messages.notifications} />,
      href: DASHBOARD_URL + 'notifications',
      hidden: true,
    },
  ];

  const DashboardFooter = [
    {
      icon: 'settings-3',
      text: <FormattedMessage {...messages.settings} />,
      href: ACCOUNT_SETTINGS_URL,
    },
  ];

  const ProfileMenu = [
    {
      text: <FormattedMessage {...messages.helpSupport} />,
      href: DASHBOARD_URL + 'support',
    },
  ];

  const MobileMenu = [
    {
      icon: 'home-2',
      text: <FormattedMessage {...messages.home} />,
      href: DASHBOARD_URL,
    },
    {
      icon: 'search',
      text: <FormattedMessage {...messages.discover} />,
      href: DASHBOARD_URL + 'discover',
    },
    {
      icon: 'lightbulb',
      text: <FormattedMessage {...messages.myLearning} />,
      href: DASHBOARD_URL + 'learning',
    },
  ];

  return { DashboardMenu, DashboardFooter, ProfileMenu, MobileMenu };
};

export default getDashboardMenu;